<template>
  <b-modal
    :id="`modaledit-${patient.id}`"
    title=""
    no-close-on-backdrop
    no-close-on-esc
    hide-footer
    :ref="`modal-${patient.id}`"
    @ok="handleOk"
    @show="show"
    data-cy="modal-paciente-edit"
  >
    <template slot="modal-title">
      <h5 data-cy="modal-paciente-edit-titulo">
        Editar Paciente: {{ patient.nome.split(" ")[0] }}
      </h5>
    </template>

    <template slot="default" slot-scope="{ ok, cancel }">
      <b-form
        :ref="`form-${patient.id}`"
        @submit.prevent="return false;"
        data-cy="form-paciente-edit"
      >
        <div
          class="mb-2"
          v-if="!patient.dependente"
          data-cy="paciente-edit-alerta"
        >
          <b-alert
            show
            variant="warning"
            dismissible
            data-cy="alerta-pagamento"
          >
            <b>Atenção:</b> Para pagamentos com
            <i><b>cartão de crédito ou boleto</b></i> é obrigatório o
            preenchimento do CPF.
          </b-alert>
        </div>
        <div class="mb-2" data-cy="paciente-edit-campo-nome">
          <label for="nome" v-required data-cy="label-nome">
            Nome {{ temNomeSocial ? "Social" : "" }}
          </label>
          <b-form-input
            class="form-control"
            type="text"
            ref="nome"
            :state="validation.nome"
            v-model="patient_new.nome"
            id="nome"
            data-cy="campo-paciente-nome"
          />
        </div>
        <div class="mb-2" data-cy="paciente-edit-campo-nome-social">
          <div class="form-group" data-cy="paciente-edit-switch-nome-social">
            <label class="switch" data-cy="switch-nome-social">
              <input
                type="checkbox"
                id="checkbox"
                :state="validation.nomeCivil"
                v-model="temNomeSocial"
                v-on:change="
                  !temNomeSocial ? (patient_new.nomeCivil = null) : ''
                "
                data-cy="checkbox-nome-social"
              />
              <span class="slider round" data-cy="slider-nome-social"></span>
            </label>
            <span data-cy="texto-nome-social"> Indicar que é nome social.</span>
          </div>
        </div>
        <div
          class="mb-2"
          v-show="temNomeSocial"
          data-cy="paciente-edit-campo-nome-civil"
        >
          <label for="nomeCivil" v-required data-cy="label-nome-civil">
            Nome Civil
          </label>
          <b-form-input
            class="form-control"
            type="text"
            ref="nomeCivil"
            :state="validation.nomeCivil"
            v-model="patient_new.nomeCivil"
            id="nomeCivil"
            data-cy="campo-paciente-nome-civil"
          />
        </div>
        <div class="mb-2" data-cy="paciente-edit-campo-nascimento">
          <label
            for="datanascimento"
            v-required
            data-cy="label-data-nascimento"
          >
            Data de Nascimento
          </label>
          <b-form-input
            class="form-control"
            ref="dataNascimento"
            :state="validation.dataNascimento"
            v-model="dataNascimento"
            id="datanascimento"
            :maxlength="10"
            placeholder="dd/mm/aaaa"
            v-mask="[`##/##/####`]"
            data-cy="campo-paciente-data-nascimento"
          />
        </div>
        <div class="mb-2" data-cy="paciente-edit-campo-sexo">
          <label for="sexo" v-required data-cy="label-sexo">
            Sexo
          </label>
          <b-form-select
            v-model="patient_new.sexo"
            :state="validation.sexo"
            :options="genders"
            id="sexo"
            ref="sexo"
            data-cy="campo-paciente-sexo"
          ></b-form-select>
        </div>
        <div class="mb-2" data-cy="paciente-edit-campo-telefone">
          <label for="telefone" v-required data-cy="label-telefone">
            Telefone
          </label>
          <b-form-input
            class="form-control"
            type="tel"
            ref="telefonePrincipal"
            :state="validation.telefonePrincipal"
            v-model="patient_new.telefonePrincipal"
            v-mask="[`(##) ####-####`, `(##) #####-####`]"
            id="telefone"
            data-cy="campo-paciente-telefone"
          />
        </div>

        <b-form-group
          id="fieldset-2"
          label="Documento"
          label-for="input-2"
          data-cy="paciente-edit-grupo-documento"
        >
          <b-form-select
            v-model="patient_new.tipoDocumento"
            :options="documentTypes"
            id="input-2"
            data-cy="campo-paciente-tipo-documento"
          ></b-form-select>
        </b-form-group>
        <b-form-group
          id="fieldset-3"
          label="Número"
          label-for="input-3"
          data-cy="paciente-edit-grupo-numero-documento"
        >
          <b-form-input
            class="form-control"
            type="tel"
            id="input-3"
            :state="validation.cpf"
            ref="numeroDocumento"
            v-mask="
              patient_new.tipoDocumento === 'CPF'
                ? '###.###.###-##'
                : 'XXXXXXXXXXXXXXXXXXXX'
            "
            v-model="patient_new.numeroDocumento"
            data-cy="campo-paciente-numero-documento"
          />
          <div class="invalid-feedback" data-cy="erro-cpf-invalido">
            CPF inválido.
          </div>
        </b-form-group>

        <b-form-group id="fieldset-5" data-cy="paciente-edit-grupo-email">
          <label
            for="input-5"
            v-required="!patient_new.dependente"
            data-cy="label-email"
          >
            E-mail
          </label>
          <b-form-input
            class="form-control"
            type="email"
            ref="email"
            :state="validation.email"
            v-model="patient_new.email"
            id="input-5"
            data-cy="campo-paciente-email"
          />
        </b-form-group>
        <div
          class="w-100 d-flex justify-content-between"
          data-cy="paciente-edit-botoes"
        >
          <b-button
            variant="white"
            class="btn-outline-primary rounded-0"
            @click="cancel()"
            data-cy="btn-paciente-edit-cancelar"
          >
            <strong>Cancelar</strong>
          </b-button>
          <b-button
            type="default"
            variant="primary"
            class="rounded-0"
            @click="ok()"
            data-cy="btn-paciente-edit-salvar"
          >
            <strong>Salvar</strong>
          </b-button>
        </div>
      </b-form>
    </template>
  </b-modal>
</template>

<script>
import {
  documentTypes,
  genders,
  validCPF,
  validEmail
} from "@/core/enumHelper";
import { mask } from "vue-the-mask";
import moment from "moment";

export default {
  name: "paciente-edit",
  props: ["patient", "titular"],
  directives: { mask },
  data() {
    return {
      validate: false,
      patient_new: null,
      temNomeSocial: false,
      validation: {
        nome: null,
        nomeCivil: null,
        sexo: null,
        dataNascimento: null,
        telefonePrincipal: null,
        cpf: null
      }
    };
  },
  created() {
    this.patient_new = { ...this.patient };
    if (this.patient.nomeCivil) {
      this.temNomeSocial = true;
    }
  },
  computed: {
    documentTypes() {
      return Object.values(documentTypes);
    },
    genders() {
      return Object.values(genders);
    },
    dataNascimento: {
      get: function() {
        this.dataNascimentoCopy = this.patient_new.dataNascimento;
        return moment(this.patient_new.dataNascimento).format("DD/MM/YYYY");
      },
      set: function(value) {
        this.dataNascimentoCopy = value;
        if (value.length === 10) {
          this.patient_new.dataNascimento = value.replace(
            /(..)\/(..)\/(....)/,
            "$3-$2-$1 23:59"
          );
        }
      }
    }
  },
  methods: {
    show() {
      this.patient_new = { ...this.patient };
      this.validation = {
        nome: null,
        dataNascimento: null,
        telefonePrincipal: null,
        cpf: null
      };
    },
    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault();

      if (!this.patient_new.nome) {
        this.validation.nome = false;
        this.$refs["nome"].focus();
        return;
      } else {
        this.validation.nome = true;
      }

      if (
        this.temNomeSocial &&
        (!this.patient_new.nomeCivil || !this.patient_new.nomeCivil.trim())
      ) {
        this.validation.nomeCivil = false;
        this.$refs["nomeCivil"].focus();
      } else {
        this.validation.nomeCivil = true;
      }

      if (
        !this.dataNascimentoCopy ||
        this.dataNascimentoCopy.length < 10 ||
        !moment(this.patient_new.dataNascimento).isValid() ||
        moment(this.patient_new.dataNascimento) > moment()
      ) {
        this.validation.dataNascimento = false;
        this.$refs["dataNascimento"].focus();
        return;
      } else {
        this.validation.dataNascimento = true;
      }

      if (
        !this.patient_new.telefonePrincipal ||
        this.patient_new.telefonePrincipal.length < 14 ||
        this.patient_new.telefonePrincipal.length > 15
      ) {
        this.validation.telefonePrincipal = false;
        this.$refs["telefonePrincipal"].focus();
        return;
      } else {
        this.validation.telefonePrincipal = true;
      }

      this.validation.cpf = null;
      if (
        this.patient_new.tipoDocumento === "CPF" &&
        this.patient_new.numeroDocumento
      ) {
        this.validation.cpf = validCPF(
          this.patient_new.numeroDocumento.replace(/[^0-9]/g, "")
        );

        if (!this.validation.cpf) {
          this.$refs["numeroDocumento"].focus();
          return;
        }
      } else {
        if (this.patient_new.numeroDocumento) {
          this.validation.cpf = true;
        }
      }

      console.log("this.patient_new: ", this.patient_new);

      if (this.patient_new.email) {
        this.validation.email = validEmail(this.patient_new.email);

        if (!this.validation.email) {
          this.$refs["email"].focus();
        }
      } else if (!this.patient_new.dependente) {
        this.validation.email = false;
      }

      if (Object.values(this.validation).indexOf(false) >= 0) {
        return;
      }

      let payload = {
        url: this.$serverHost,
        patient: this.patient_new,
        titular: this.titular,
        action: () => {
          this.$refs[`modal-${this.patient.id}`].hide();
        },
        error: e => {
          this.$bvToast.toast(e.response ? e.response.data.message : e, {
            title: "Erro",
            variant: "danger",
            autoHideDelay: 5000,
            appendToast: true
          });
        }
      };

      this.$store.dispatch("alter_patient", payload);
    }
  }
};
</script>

<style></style>
